import React from 'react';
import IMG_LOADING from '../../assets/images/spinner.svg';

const Loading = () => (
  <div className="fixed left-0 top-0 w-full h-full flex bg-[#00000000] z-[99999]">
    <div className="w-[40px] h-[40px] m-auto">
      <img src={IMG_LOADING} alt="loading" className="w-full h-full" />
    </div>
  </div>
);
export default Loading;
